/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { useIntl } from 'react-intl';

import SupportContactSection from './SupportContactSection';
import messages from 'src/shared/app/authentication/l10n/contactL10n';
import DocumentTitle from 'src/shared/app/base/component/document/DocumentTitle';

const SupportContactMain = (): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const intl = useIntl();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <React.Fragment>
      <DocumentTitle>{intl.formatMessage(messages.success)}</DocumentTitle>
      <SupportContactSection />
    </React.Fragment>
  );
};

export default compose(React.memo)(SupportContactMain);
